import 'core-js/es6/map'
import 'core-js/es6/set'
import 'core-js/es6/promise'
import 'core-js/modules/es6.array.find'

if (!global.Intl) {
  require('intl')
}
